import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import Sidebar from '../components/Sidebar';

const Dashboard = () => {
  const [user, setUser] = useState({ name: "Student" });
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('userInfo'));
    if (storedUser) setUser(storedUser);

    
    const fetchHistory = async () => {
      try {
        const { data } = await api.get('/auth/history');
        setHistory(data.slice(0, 3));
      } catch (error) {
        console.error("Failed to load history on dashboard");
      }
    };
    fetchHistory();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar />
      
      <div className="flex-1 md:ml-64 p-8 pb-24">
        
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Hello, {user.name}! 👋</h1>
          <p className="text-gray-500 mt-2">Build better applications with analysis, outreach, and stronger resume content.</p>
        </div>

        <div className="grid md:grid-cols-4 gap-6 mb-12">
          
          <Link to="/tools/ats" className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition-all group">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">📄</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">ATS Checker</h3>
            <p className="text-gray-500 text-sm">Check resume quality, structure, and ATS readiness.</p>
          </Link>

          <Link to="/tools/jd-match" className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition-all group">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">🎯</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">JD Matching</h3>
            <p className="text-gray-500 text-sm">Compare your resume with a specific job description.</p>
          </Link>

          <Link to="/tools/email" className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition-all group">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">✉️</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Cold Email Generator</h3>
            <p className="text-gray-500 text-sm">Generate personalized outreach emails for each application.</p>
          </Link>

          <Link to="/tools/fixer" className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition-all group">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">✍️</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Bullet Improvement</h3>
            <p className="text-gray-500 text-sm">Turn raw project notes into sharp, resume-ready bullet points.</p>
          </Link>
        
        </div>

        <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">Recent Application Activity</h2>
            <Link to="/history" className="text-blue-600 font-medium text-sm hover:underline">View All</Link>
        </div>

        <div className="bg-white rounded-xl shadow-sm border divide-y overflow-hidden">
          {history.length === 0 ? (
            <div className="p-8 text-center text-gray-400">
                <p>No activity yet.</p>
                <Link to="/tools/ats" className="text-blue-500 text-sm font-bold mt-2 block">Start with ATS Checker</Link>
            </div>
          ) : (
            history.map((scan, index) => (
              <div key={index} className="p-4 flex justify-between items-center hover:bg-gray-50 transition-colors">
                <div>
                  <div className="font-bold text-gray-700">{scan.title || "Application Activity"}</div>
                  <div className="text-sm text-gray-500">{scan.company || "PlacementPro"}</div>
                  <div className="text-xs text-gray-400">
                    {new Date(scan.date).toLocaleDateString()}
                  </div>
                </div>

                {typeof scan.score === 'number' ? (
                  <div className={`px-3 py-1 rounded-full text-sm font-bold 
                      ${scan.score >= 70 ? 'bg-green-100 text-green-700' : scan.score >= 40 ? 'bg-orange-100 text-orange-700' : 'bg-red-100 text-red-700'}`}>
                    {scan.score}%
                  </div>
                ) : (
                  <div className="px-3 py-1 rounded-full text-sm font-bold bg-gray-100 text-gray-600 capitalize">
                    {scan.type || 'activity'}
                  </div>
                )}
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
